import { API_HOST_PREV, API_HOST_DINA, KEY_DINA } from "../utils/const";
import { registrarFalloConexion } from "../utils/logConexionFallo";

/** Tiempo máximo de espera por defecto (ms) si no se pasa `time` en config. */
const DEFAULT_FETCH_TIMEOUT_MS = 45000;

export const fetchRequestPrev = async (url, config) => {
  let { method, headers, body, token, time } = config;
  let timeout = time ?? DEFAULT_FETCH_TIMEOUT_MS;
  if (method != "GET") {
    body = JSON.stringify(body);
    headers = { "Content-Type": "application/json", ...headers };
  }
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      const err = {
        error: "No se puede conectar al servidor",
        response: 408,
        message: "Request timeout",
      };
      registrarFalloConexion({
        baseUrl: API_HOST_PREV,
        url,
        providerLabel: 'conect_prev',
        token,
        error: err,
      });
      reject(err);
    }, timeout);

    fetch(`${API_HOST_PREV}/${url}`, {
      body: body,
      headers: {
        ...headers,
        Authorization: `Bearer ${token}`,
      },
      method: method,
    })
      .then(async (response) => {
        if (response.status > 100 && response.status < 300) {
          const json = await response.json();
          if (json) {
            clearTimeout(timer);
            resolve(json);
          }
        } else if (response.status > 400) {
          const json = await response.json();
          if (json) {
            clearTimeout(timer);
            reject(json);
          }
        }
      })
      .catch((error) => {
        clearTimeout(timer);
        registrarFalloConexion({
          baseUrl: API_HOST_PREV,
          url,
          providerLabel: 'conect_prev',
          token,
          error: { error },
        });
        reject({ error });
      });
  });
};

export const fetchRequestDinamica = async (url, config) => {
  let { method, headers, body, time, token } = config;
  let timeout = DEFAULT_FETCH_TIMEOUT_MS;
  if (method != "GET") {
    body = JSON.stringify(body);
    headers = { "Content-Type": "application/json", ...headers };
  }
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      const err = {
        error: "No se puede conectar al servidor",
        response: 408,
        message: "Request timeout",
      };
      registrarFalloConexion({
        baseUrl: API_HOST_DINA,
        url,
        providerLabel: 'conect_prev_dinamica',
        token,
        error: err,
      });
      reject(err);
    }, timeout);

    fetch(`${API_HOST_DINA}/${url}`, {
      body: body,
      headers: {
        ...headers,
        Authorization: `${KEY_DINA}`,
      },
      method: method,
    })
      .then(async (response) => {
        if (response.status >= 200 && response.status < 300) {
          try {
            const json = await response.json();
            clearTimeout(timer);
            resolve(json);
          } catch (e) {
            clearTimeout(timer);
            resolve({ success: true, message: 'Operación realizada correctamente pero sin respuesta JSON' });
          }
        } else {
          try {
            const json = await response.json();
            clearTimeout(timer);
            reject(json);
          } catch (e) {
            clearTimeout(timer);
            reject({ error: 'Error del servidor sin detalles', status: response.status });
          }
        }
      })
      .catch((error) => {
        clearTimeout(timer);
        registrarFalloConexion({
          baseUrl: API_HOST_DINA,
          url,
          providerLabel: 'conect_prev_dinamica',
          token,
          error: { error },
        });
        reject({ error });
      });
  });
};
